import React, { ReactNode } from 'react'
import DashboardBg from "../../assets/Images/DashboardBG.png";

interface DashboardBackgroundProps {
    children: ReactNode;
}  

const DashboardBackground = ({children}:DashboardBackgroundProps) => {
  return (
    <div
    className="flex min-h-screen w-full"
    style={{
      backgroundImage: `url(${DashboardBg})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    }}
    key='dashboardBackground'
  >
    {children}
  </div>
  )
}

export default DashboardBackground